<template>
    <div class="ppv-layer-outer">
      <div class="ppv-layer-inner">
        <span class="ppv-intro" :style="`color:${guideColor}`">{{guide}}</span>
        <a href="#" class="ppv-link" @click.prevent="goPpvPage">
          <span :style="`color:${destinationColor}`">{{destination}}&nbsp;</span>
          <span :style="`color:${actionColor}`">{{action}}</span></a>
        <span class="ppv-notification"><span :style="`color:${noticeColor}`">{{notice}}</span></span>
      </div>
    </div>
</template>
<script>
  import _ from 'lodash'
  import CellMixIn from '@/mixins/cell.mixin'
  import { hasUserConfirmPPV } from '@/common/utils/common'
  import cookie from '@/common/utils/cookie'
  export default {
    componentName: 'PpvWrapper',
    mixins: [
      CellMixIn
    ],
    props: {
      buttonInfo: {
        type: Object
      }
    },
    methods: {
      goPpvPage () {
        if (hasUserConfirmPPV()) {
           this.$events.$emit('OPEN_PPV_TOAST', () => {
           this.goDetail(this.buttonInfo)
          }, _.get(this.buttonInfo, 'confirmation.guide_text', ''))
        } else {
          this.$events.$emit('OPEN_PPV_POPUP', this.ppvConfirm,
            _.get(this.buttonInfo, 'confirmation.guide_title', ''),
            _.get(this.buttonInfo, 'confirmation.guide_text', '')
          )
        }
      },
      ppvConfirm () {
        cookie.setMovieUiCodeToGN17()
        this.goDetail(this.buttonInfo)
      }
    },
    computed: {
      destination () {
        return _.get(this.buttonInfo, ['destination', 'title'], '')
      },
      destinationColor () {
        return _.get(this.buttonInfo, ['destination', 'color'], '#FFFFFF')
      },
      action () {
        return _.get(this.buttonInfo, ['action', 'title'], '')
      },
      actionColor () {
        return _.get(this.buttonInfo, ['action', 'color'], '#FFFFFF')
      },
      guide () {
        return _.get(this.buttonInfo, ['guide', 'title'], '')
      },
      guideColor () {
        return _.get(this.buttonInfo, ['guide', 'color'], '#FFFFFF')
      },
      notice () {
        return _.get(this.buttonInfo, ['notice', 'title'], '')
      },
      noticeColor () {
        return _.get(this.buttonInfo, ['notice', 'color'], '#FFFFFF')
      }
    }
  }

</script>
<style scoped>
  .ppv-layer-outer{
    position: absolute;
    top: 0;
    display: block;
    content: '';
    width: 100%;
    z-index: 2;
    height: calc(100% - 80px);
    color: #fff;
    background-color: rgba(0, 0, 0, 0.7);
  }
  .ppv-layer-inner{
    width: 1240px;
    margin: 0 auto;
  }
  .ppv-intro,
  .ppv-link,
  .ppv-notification{
    display: block;
    text-align: center;
  }
  .ppv-intro{
    margin-top: 149px;
    margin-bottom: 8px;
    font-size: 36px;
    line-height: 54px;
  }
  .ppv-link{
    width: 285px;
    margin: 0 auto;
    padding: 20px 0;
    font-size: 18px;
    line-height: 27px;
    color: #fff;
    background-color: #1351f9;
    border-radius: 34px;
  }
  .ppv-notification{
    position: relative;
    margin-top: 64px;
    color: #a5a5a5;
  }
  .ppv-notification >span{
    font-size: 16px;
    line-height: 24px;
    display: inline-block;
    vertical-align: middle;
  }
</style>
